import {
  ArrowIcon,
  PulldownCheckIcon,
  SmallDownwardArrowIcon,
} from '@prtimes-basis/icons';
import * as Select from '@radix-ui/react-select';
import {type CSSProperties, forwardRef} from 'react';
import {clsx} from 'clsx';
import styles from './pulldown.module.css';

type Props = Omit<Select.SelectProps, 'children'> & {
  readonly onChange: (newValue: string) => void;
  readonly options: Array<{
    key: string;
    value: string;
  }>;
  readonly value?: string;
  readonly defaultValue?: string;
  readonly error?: boolean;
  readonly placeholder?: string;
  readonly id?: string;
  readonly className?: string;
  readonly style?: CSSProperties;
};

export const Pulldown = forwardRef<HTMLButtonElement, Props>(
  (
    {
      onChange,
      options,
      value,
      defaultValue,
      error = false,
      placeholder,
      id,
      className,
      ...props
    },
    reference,
  ) => (
    <Select.Root
      // 初期値 '' の時に placeholder を表示するため、undefined （未選択）として扱う
      value={value === '' ? undefined : value}
      defaultValue={defaultValue}
      onValueChange={onChange}
    >
      <Select.Trigger
        ref={reference}
        id={id}
        className={clsx(styles.trigger, error && styles.error, className)}
        aria-invalid={error}
        {...props}
      >
        <Select.Value placeholder={placeholder} />
        <Select.Icon>
          <SmallDownwardArrowIcon variant='gray' />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          /**
           * triggers a touch event on elements positioned behind
           * https://github.com/radix-ui/primitives/issues/1658#issuecomment-2118856364
           * */
          // ref={(ref) =>
          //   ref?.addEventListener('touchend', (event) => {
          //     event.preventDefault();
          //   })
          // }
          className={styles.content}
        >
          <Select.ScrollUpButton className={styles.scrollChevron}>
            <ArrowIcon variant='gray' direction='up' />
          </Select.ScrollUpButton>
          <Select.Viewport>
            {options.map((option) => (
              <Select.Item
                key={option.value + option.key}
                className={styles.item}
                value={option.value}
              >
                <Select.ItemIndicator className={styles.itemIndicator}>
                  <PulldownCheckIcon />
                </Select.ItemIndicator>
                <Select.ItemText>{option.key}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
          <Select.ScrollDownButton className={styles.scrollChevron}>
            <ArrowIcon variant='gray' direction='down' />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  ),
);

Pulldown.displayName = 'Pulldown';
